import React, { useCallback, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronDown, ChevronUp, Briefcase, BookOpen, HelpCircle } from 'lucide-react';
export function Header() {
  const location = useLocation();
  const isThankYouPage = location.pathname === '/thankyou';
  const isCasesPage = location.pathname === '/cases';
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout>();
  const handleMouseEnter = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsServicesOpen(true);
  }, []);
  const handleMouseLeave = useCallback(() => {
    timeoutRef.current = setTimeout(() => {
      setIsServicesOpen(false);
    }, 150);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  // Hide header on cases page
  if (isCasesPage) {
    return null;
  }
  return <header className="fixed top-0 left-0 right-0 z-50 w-full py-3 px-6 md:px-12 flex justify-between items-center bg-black/90 backdrop-blur-sm border-b border-white/10" data-id="element-38">
      <div className="flex items-center gap-12" data-id="element-39">
        <h1 className="text-lg font-medium" data-id="element-40">Cases On Command</h1>
        {!isThankYouPage && <nav className="hidden md:flex items-center gap-8" data-id="element-41">
            <div className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} data-id="element-42">
              <button onClick={() => setIsServicesOpen(!isServicesOpen)} className="flex items-center gap-2 text-sm hover:text-primary transition-colors py-2 px-1" data-id="element-43">
                <Briefcase size={16} data-id="element-44" />
                Services
                {isServicesOpen ? <ChevronUp size={16} data-id="element-45" /> : <ChevronDown size={16} data-id="element-46" />}
              </button>
              {isServicesOpen && <div className="absolute top-full left-0 mt-1 w-80 bg-black/95 border border-white/10 rounded-md shadow-xl" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} data-id="element-47">
                  <div className="py-2" data-id="element-48">
                    <a href="https://calendly.com/customers-on-command/customers-on-command-1-1-interview" target="_blank" rel="noopener noreferrer" className="block w-full px-8 py-4 text-sm text-white hover:text-primary hover:bg-white/5 transition-all duration-200 cursor-pointer" data-id="element-49">
                      Immigration / Law Firm Solutions
                    </a>
                  </div>
                </div>}
            </div>
            <button onClick={() => scrollToSection('case-studies')} className="flex items-center gap-2 text-sm hover:text-primary transition-colors py-2 px-1" data-id="element-50">
              <BookOpen size={16} data-id="element-51" />
              Case Studies
            </button>
            <button onClick={() => scrollToSection('why-us')} className="flex items-center gap-2 text-sm hover:text-primary transition-colors py-2 px-1" data-id="element-52">
              <HelpCircle size={16} data-id="element-53" />
              Why Us
            </button>
          </nav>}
      </div>
    </header>;
}